var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudiencesSvg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "17px",
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "user") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navbar-new",
    transform: "translate(-31.000000, -288.000000)",
    fill: "#418AFE",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user",
    transform: "translate(31.000000, 288.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,9.31764706 C5.44589474,9.31764706 3.36842105,7.22795294 3.36842105,4.65882353 C3.36842105,2.08969412 5.44589474,0 8,0 C10.5541053,0 12.6315789,2.08969412 12.6315789,4.65882353 C12.6315789,7.22795294 10.5541053,9.31764706 8,9.31764706 Z M8,0.847058824 C5.91073684,0.847058824 4.21052632,2.55727059 4.21052632,4.65882353 C4.21052632,6.76037647 5.91073684,8.47058824 8,8.47058824 C10.0892632,8.47058824 11.7894737,6.76037647 11.7894737,4.65882353 C11.7894737,2.55727059 10.0892632,0.847058824 8,0.847058824 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7368421,16.9411765 L1.26315789,16.9411765 C0.566736842,16.9411765 0,16.3711059 0,15.6705882 C0,15.6129882 0.0117894737,14.2432941 1.03157895,12.8752941 C1.62526316,12.0790588 2.43789474,11.4463059 3.44757895,10.9956706 C4.68042105,10.4442353 6.21221053,10.1647059 8,10.1647059 C9.78778947,10.1647059 11.3195789,10.4442353 12.5524211,10.9956706 C13.5621053,11.4471529 14.3747368,12.0790588 14.9684211,12.8752941 C15.9882105,14.2432941 16,15.6129882 16,15.6705882 C16,16.3711059 15.4332632,16.9411765 14.7368421,16.9411765 Z M8,11.0117647 C5.06357895,11.0117647 2.89684211,11.8190118 1.73389474,13.3462588 C0.862315789,14.4906353 0.842947368,15.6604235 0.842105263,15.6722824 C0.842105263,15.9043765 1.03073684,16.0941176 1.26315789,16.0941176 L14.7368421,16.0941176 C14.9692632,16.0941176 15.1578947,15.9043765 15.1578947,15.6705882 C15.1578947,15.6604235 15.1385263,14.4906353 14.2661053,13.3462588 C13.1023158,11.8190118 10.9355789,11.0117647 8,11.0117647 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudiencesSvg);
export default __webpack_public_path__ + "static/media/Audiences_svg.177e9a6e9f9c7820ea254f653668813b.svg";
export { ForwardRef as ReactComponent };